import { buildAction } from 'store/actions/actionCreator'

import {
  FETCH_RANKING_HOURLY_COUNTRIES,
  FETCH_RANKING_HOURLY_STORES,
  FETCH_RANKINGS_COUNTRIES,
  HIDE_FILTER_COUNTRY_MODAL,
  OPEN_FILTER_COUNTRY_MODAL,
  SET_FILTER_COUNTRY_INPUT,
  SET_INDICATOR,
  SET_RANKING,
  SET_SELECTED_COUNTRIES,
  SET_SELECTED_COUNTRY,
  SET_SELECTED_COUNTRY_COMPARED,
  SET_SELECTED_STORE,
  SET_SELECTED_STORE_COMPARED,
  SET_SORT,
  TOGGLE_ARE_FILTERS_EXPANDED,
  TOGGLE_COLLAPSED,
  TOGGLE_WEEKLY,
} from './constants'

export const fetchRankingsCountries = buildAction(FETCH_RANKINGS_COUNTRIES)

export const fetchRankingHourlyCountries = buildAction(FETCH_RANKING_HOURLY_COUNTRIES)

export const fetchRankingHourlyStores = buildAction(FETCH_RANKING_HOURLY_STORES)

export const toggleCollapsed = buildAction(TOGGLE_COLLAPSED)

export const toggleWeekly = buildAction(TOGGLE_WEEKLY)

export const setSelectedCountry = buildAction(SET_SELECTED_COUNTRY, 'payload')

export const setSelectedCountryCompared = buildAction(SET_SELECTED_COUNTRY_COMPARED, 'payload')

export const setSelectedStore = buildAction(SET_SELECTED_STORE, 'payload')

export const setSelectedStoreCompared = buildAction(SET_SELECTED_STORE_COMPARED, 'payload')

export const setRanking = buildAction(SET_RANKING, 'payload')

export const setIndicator = buildAction(SET_INDICATOR, 'payload')

export const toggleAreFiltersExpanded = buildAction(TOGGLE_ARE_FILTERS_EXPANDED)

export const setSort = buildAction(SET_SORT, 'payload')

export const openFilterCountryModal = buildAction(OPEN_FILTER_COUNTRY_MODAL)

export const hideFilterCountryModal = buildAction(HIDE_FILTER_COUNTRY_MODAL)

export const setFilterCountryInput = buildAction(SET_FILTER_COUNTRY_INPUT, 'payload')

export const setSelectedCountries = buildAction(SET_SELECTED_COUNTRIES, 'payload')
